import React from "react";
import { FaShippingFast, FaMoneyBillWave, FaHeadset, FaLock } from "react-icons/fa";

const features = [
  {
    title: "Free Shipping & Returns",
    icon: <FaShippingFast className="text-blue-600 text-2xl" />,
  },
  {
    title: "Money Back Guarantee",
    icon: <FaMoneyBillWave className="text-green-600 text-2xl" />,
  },
  {
    title: "Online Support 24/7",
    icon: <FaHeadset className="text-orange-500 text-2xl" />,
  },
  {
    title: "Secure Payment",
    icon: <FaLock className="text-purple-600 text-2xl" />,
  },
];

const ServiceFeatures = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 p-6 bg-white rounded-xl shadow">
      {features.map((feature, idx) => (
        <div
          key={idx}
          className="flex items-center gap-4 bg-gray-50 p-4 rounded-lg shadow-sm cursor-pointer hover:bg-gray-200 hover:scale-105 transition duration-300 ease-in-out"
        >
          <div className="p-2 rounded-full bg-white shadow">{feature.icon}</div>
          <h3 className="font-semibold text-base">{feature.title}</h3>
        </div>
      ))}
    </div>
  );
};

export default ServiceFeatures;